import React from 'react';
import { motion } from 'framer-motion';
import { EbookMockup } from './EbookMockup';
export function BonusSection() {
  return <section className="py-16 px-4 md:py-24 bg-[#F5F5F5]" data-id="element-15">
      <div className="max-w-[800px] mx-auto" data-id="element-16">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-17">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-gray-900" data-id="element-18">
            Y además si comprás <span className="text-[#00A86B]" data-id="element-19">HOY</span> te
            regalo 2 <span className="text-[#00A86B]" data-id="element-20">BONUS</span> EXCLUSIVOS
          </h2>
        </motion.div>

        <div className="space-y-6 mb-10" data-id="element-21">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="rounded-2xl p-6 shadow-md flex flex-col sm:flex-row items-center sm:items-start gap-6 border border-yellow-100 bg-[#E8DEDE]" data-id="element-22">
            <div className="flex-shrink-0" data-id="element-23">
              <EbookMockup title="PLAN KETO" subtitle="14 DÍAS" imageSrc="https://cdn.magicpatterns.com/uploads/pHJcBaF8tAGc3pvzQuCRwx/plan_keto.png" className="w-[140px] h-auto" data-id="element-24" />
            </div>
            <div className="text-center sm:text-left flex-1" data-id="element-25">
              <span className="inline-block bg-[#00A86B]/10 font-bold text-xs px-2.5 py-1 rounded-md mb-3 text-[#00A86A]" data-id="element-26">
                🎁 REGALO #1
              </span>
              <h3 className="font-heading font-bold text-xl mb-2 text-[#000000]" data-id="element-27">
                Plan Keto 14 Días
              </h3>
              <p className="text-sm leading-relaxed mb-4 text-[#000000]" data-id="element-28">
                El bonus más valioso. Un plan día por día con desayuno,
                almuerzo, snacks y cena armados para vos. Ya no tenés que
                pensar. Abrís el plan, ves qué toca hoy, cocinás y listo.
              </p>
              <div className="text-sm" data-id="element-29">
                <span className="text-gray-400 line-through mr-2" data-id="element-30">
                  Valor real: $19.000
                </span>
                <span className="font-bold text-[#00A86A]" data-id="element-31">— Hoy: GRATIS</span>
              </div>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="rounded-2xl p-6 shadow-md flex flex-col sm:flex-row items-center sm:items-start gap-6 border border-yellow-100 bg-[#E8DEDE]" data-id="element-32">
            <div className="flex-shrink-0" data-id="element-33">
              <EbookMockup title="UNTABLES" subtitle="KETO" imageSrc="https://cdn.magicpatterns.com/uploads/gJaMWkWzFoovrquJy3TAC1/Gemini_Generated_Image_1nf30o1nf30o1nf3.png" className="w-[140px] h-auto" data-id="element-34" />
            </div>
            <div className="text-center sm:text-left flex-1" data-id="element-35">
              <span className="inline-block bg-[#00A86B]/10 text-[#00A86B] font-bold text-xs px-2.5 py-1 rounded-md mb-3" data-id="element-36">
                🎁 REGALO #2
              </span>
              <h3 className="font-heading font-bold text-xl mb-2 text-[#000000]" data-id="element-37">
                Untables Keto
              </h3>
              <p className="text-sm leading-relaxed mb-4 text-[#000000]" data-id="element-38">
                El secreto para que keto sea sostenible: que la comida nunca sea
                aburrida. Mantecas saborizadas, mayonesas caseras keto,
                guacamoles y más.
              </p>
              <div className="text-sm" data-id="element-39">
                <span className="text-gray-400 line-through mr-2" data-id="element-40">
                  Valor real: $25.000
                </span>
                <span className="text-[#00A86B] font-bold" data-id="element-41">— Hoy: GRATIS</span>
              </div>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="border-2 border-[#00A86B] rounded-2xl p-6 text-center shadow-lg bg-[#FFF9EE]" data-id="element-42">
          <p className="font-medium mb-1 text-[#000000]" data-id="element-43">
            Valor total de los bonus:{' '}
            <span className="line-through" data-id="element-44">$44.000</span>
          </p>
          <p className="font-heading font-extrabold text-2xl text-[#00A86B]" data-id="element-45">
            HOY GRATIS
          </p>
        </motion.div>
      </div>
    </section>;
}